<template>
  <v-layout row>
    <v-dialog v-model="error" width="500">
      <v-card>
        <v-card-title class="headline red accent-3" primary-title>
          Warning Message
        </v-card-title>

        <v-card-text>
          {{ errorMsg }}
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red accent-3" flat @click="error = 0">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div>
      <v-snackbar
        v-model="snackbar"
        :right="x === 'right'"
        :timeout="timeout"
        :color="color"
        :top="y === 'top'"
      >
        {{ msg }}
        <v-btn color="white" flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </div>
    <v-layout xs12>
      <v-flex xs12>
        <div class="px-2" style="min-height: 450px">
          <v-img
            class="mt-4"
            :src="require('@/assets/Ask-for-Demo.svg')"
          ></v-img>
        </div>
      </v-flex>
      <v-flex xs12 class="ml-2">
        <v-card-title class="white darken-1 text-xs-center">
          <span class="headline mx-auto">Request Information</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- <v-container> -->
            <!-- <v-layout wrap> -->
            <v-layout row>
              <v-flex xs12 md4 class="mr-2">
                <v-text-field
                  v-model="firstName"
                  :rules="[(v) => !!v || 'First name is required']"
                  label="First Name*"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 class="mr-2">
                <v-text-field
                  v-model="lastName"
                  :rules="[(v) => !!v || 'Last Name is required']"
                  label="Last Name*"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md4 class="mr-2">
                <v-text-field
                  v-model="email"
                  :rules="[(v) => !!v || 'Email is required']"
                  label="Email*"
                  type="email"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 md4 class="mr-2">
                <v-text-field
                  v-model="phone"
                  :rules="[(v) => !!v || 'Phone is required']"
                  label="Phone*"
                  required
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md8 class="mr-2">
                <v-text-field
                  v-model="subject"
                  :rules="[(v) => !!v || 'Subject is required']"
                  label="Subject*"
                  required
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12 class="ml-2">
                <v-textarea
                  v-model="requestingInfo"
                  :rules="[(v) => !!v || 'Requesting Info is required']"
                  label="Requesting Info*"
                  required
                ></v-textarea>
              </v-flex>
            </v-layout>
            <!-- </v-layout> -->
            <!-- </v-container> -->
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red darken-1"
            class="btn-large v-btn--round white--text"
            
            @click="storeOrUpdate"
            >Request Demo</v-btn
          >
        </v-card-actions>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import api from "../api/datadash";
import { mapState } from "vuex";

export default {
  data: () => ({
    error: 0,
    errorMsg: "",
    valid: true,
    snackbar: false,
    color: "success",
    msg: "Submitted successfully",
    y: "top",
    x: "right",
    timeout: 3000,
    dialog: false,
    firstName: null,
    lastName: null,
    email: "",
    phone: "",
    subject: null,
    requestingInfo: null,
  }),

  computed: {
    ...mapState(["auth"]),
  },
  async mounted() {
    // await this.getDivDistUpz();
  },

  created() {
    // this.initialize();
  },

  methods: {
    async storeOrUpdate() {
      this.loading = true;
      try {
        const { data } = await api.storeData(this.auth.token, "request-demo", {
          first_name: this.firstName,
          last_name: this.lastName,
          email: this.email,
          phone: this.phone,
          subject: this.subject,
          requesting_info: this.requestingInfo,
        });

        if (data.error) {
          this.color = "error";
          this.msg = data.errorMsg;
        } else {
          this.color = "success";
          this.msg = "Demo request submitted successfully";
          this.$refs.form.reset();
        }

        this.snackbar = true;
        this.loading = false;
        this.close();
      } catch (e) {
        // console.log(e);
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {}, 300);
    },
  },
};
</script>
